import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SelectedItemState } from '@ui/shared/domain-map';
import { MapItem } from '@ui/shared/util-map';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-popup-view-container',
    templateUrl: './popup-view-container.component.html',
    styleUrls: ['./popup-view-container.component.scss'],
    standalone: false,
})
export class PopupViewContainerComponent<MapItemType extends MapItem> {
    constructor(
        private readonly _selectedMapItemService: SelectedItemState<MapItemType>,
    ) {}

    public openMapItemDetails(event: Event): void {
        event.preventDefault();

        this._selectedMapItemService.setShowDetailView(true);
    }
}
